import PropTypes from "prop-types";
import * as React from "react";
import isNumber from "lodash/isNumber";
import { StatisticsValue } from "UIKit";
import { thousands } from "helpers/formatting";
import styles from "./ResourceCell.scss";

class ResourceCell extends React.PureComponent {

  static propTypes = {
    memberId: PropTypes.number.isRequired,

    value: PropTypes.number,
    isHidden: PropTypes.bool,
    canViewLeveling: PropTypes.bool,
    isBonusActivated: PropTypes.bool,
    isHighlightedAdmittance: PropTypes.bool,
    disableTooltip: PropTypes.bool
  };

  isNeedTooltip() {
    return (!this.props.disableTooltip && isNumber(this.props.value) && this.props.canViewLeveling && !this.props.isBonusActivated);
  }

  render() {
    let dataTip = null;
    let tooltipId = null;
    if (this.isNeedTooltip()) {
      dataTip = this.props.memberId;
      tooltipId = 'accumulative-clan-resource-tooltip';
    }

    const classNameResourceCell = !this.props.isHighlightedAdmittance ? null : styles.isHighlightedAdmittance;

    return <div data-tip={dataTip} data-for={tooltipId} className={classNameResourceCell}>
                <StatisticsValue value={thousands(this.props.value)} isHidden={this.props.isHidden} disableTooltip={this.props.disableTooltip} />
            </div>;
  }
}


export default ResourceCell;